<template>
  <div :class="$style.law_info">
    <MoleculesConsumerHeading title="特定商取引法に基づく表記" />
    <div :class="$style.content">
      <dl>
        <dt>販売業者名</dt>
        <dd>株式会社TENTIAL</dd>
      </dl>
      <dl>
        <dt>販売責任者</dt>
        <dd>中西 裕太郎</dd>
      </dl>
      <dl>
        <dt>所在地</dt>
        <dd>〒141-0001 東京都品川区北品川6-7-29 ガーデンシティ品川御殿山 西館5階</dd>
      </dl>
      <dl>
        <dt>電話番号</dt>
        <dd>
          03-6455-2921<br />
          [受付時間] 平日10:30～17:30 <br />
          ※ 現在電話が繋がりにくくなっております。<br />
          <AtomsConsumerLink :class="$style.link" :url="FAQ_URL" blank> よくあるご質問はこちら </AtomsConsumerLink>
        </dd>
      </dl>
      <dl>
        <dt>メールアドレス</dt>
        <dd>support@tential.jp</dd>
      </dl>
      <dl>
        <dt>サイト名</dt>
        <dd>TENTIAL Online Store</dd>
      </dl>
      <dl>
        <dt>ホームページURL</dt>
        <dd>
          <AtomsConsumerLink :class="$style.link" url="https://tential.jp" blank>https://tential.jp</AtomsConsumerLink>
        </dd>
      </dl>
      <dl>
        <dt>販売価格</dt>
        <dd>各商品ページに税別金額を記載</dd>
      </dl>
      <dl>
        <dt>配送業者</dt>
        <dd>佐川急便、日本郵便</dd>
      </dl>
      <dl>
        <dt>送料</dt>
        <dd>無料</dd>
      </dl>
      <dl>
        <dt>配送時期</dt>
        <dd>
          最短1~2営業日(土日祝は休業日)でのお届けになります。
          <br />（※例外：北海道、長崎、大分、鹿児島、沖縄：2~3営業日、沖縄の一部、離島：3~5営業日）
          <br />
          注文状況により配送まで最大5営業日頂戴することがございます。あらかじめご了承ください。
        </dd>
      </dl>
      <dl>
        <dt>消費税</dt>
        <dd>
          当サイトの税込金額は消費税率10％（軽減税率商品は8%）で計算しております。
          <br />消費税率が変更になった場合は、税込金額も変更になります。
        </dd>
      </dl>
      <dl>
        <dt>決済手数料</dt>
        <dd>
          代金引換：385円（税込)<br />
          クレジットカード決済：無料<br />
          Amazon Pay：無料<br />
          ※ただし、リボ払いや分割の場合、カード会社の規定により手数料がかかる場合があります<br />
        </dd>
      </dl>
      <dl>
        <dt>決済期間</dt>
        <dd>
          クレジットカード決済の場合はただちに処理されますが、コンビニ払いの場合は注文から3日以内にお支払いいただく必要があります。
        </dd>
      </dl>
      <dl>
        <dt>お支払い方法</dt>
        <dd>
          お支払いは以下の方法で可能です。<br />
          各クレジットカード(VISA・MASTER・JCB・AMEX・Diners)<br />
          Amazon Pay<br />
          代金引換<br />
        </dd>
      </dl>
      <dl>
        <dt>領収書の発行</dt>
        <dd>
          <span :class="$style.sub_title">【クレジットカード・Amazon Payでお支払いの場合】</span>
          <br />注文完了メールを領収書としているため、必要に応じてプリントアウトしてご利用いただけますと幸いです。
          <br /><span :class="$style.sub_title">【代金引換でお支払いの場合】</span>
          <br />お届けした際に、代金引換のお支払いの受領時に配送会社からお渡ししている「代引金額領収書(送り状)」が領収書となります。
          <br />
          <br />また、大変恐れ入りますが領収書の再発行・名前変更・分割につきましては対応しておりません。
          <br />予めご了承くださいませ。
        </dd>
      </dl>
      <dl>
        <dt>返品・交換について</dt>
        <dd>
          <span :class="$style.sub_title">【返品について】</span>
          <br />お客様都合による返品は、原則として承っておりません。（商品に不備/不具合がある場合を除く）
          <br />返品可能商品は以下のトライアル・保証対象商品のみとなります。 <br />▼30日トライアル対象商品
          <br />ご購入日を含む30日以内 <br />▼120日返品保対象商品 <br />ご購入日を含む120日以内
          <br />
          <span :class="$style.sub_title">【交換について】</span>
          <br />▼オンラインストア購入の場合 <br />商品出荷日を含む14日以内であれば交換が可能です。
          <br />※オンラインストア購入商品の返品・交換可能期間は［購入履歴］よりご確認いただけます。
          <br />▼直営店舗購入の場合 <br />ご購入日を含む14日以内であれば交換が可能です。
          <br />
          <span :class="$style.sub_title">【注意事項】</span>
          <br />
          <AtomsConsumerLink :class="$style.link" :url="FAQ_URL_CAN_RETURN_EXCHANGE">
            「よくあるご質問＞返品・交換できない商品はありますか？」
          </AtomsConsumerLink>
          をご確認ください。
          <br />
          <span :class="$style.sub_title">【お手続き方法について】</span>
          <br />
          ご購入場所などによりお手続きが異なります。
          <br />
          詳細は
          <AtomsConsumerLink :class="$style.link" :url="FAQ_URL_RETURN_EXCHANGE_CATEGORY">
            「よくあるご質問＞返品・交換のカテゴリ」
          </AtomsConsumerLink>
          をご参照ください。
          <br />
          <span :class="$style.sub_title">【返送料について】</span>
          <br />返送の際の送料は、原則お客様のご負担となります。但し、商品不良・欠損の場合は着払い（弊社負担）でご返送ください。
        </dd>
      </dl>
      <dl>
        <dt>注意事項</dt>
        <dd>
          ウェブサイトでの商品の色合いやデザインは、製造時期により実際の商品と若干異なる場合がございます。ご容赦ください。
        </dd>
      </dl>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  FAQ_URL,
  FAQ_URL_CAN_RETURN_EXCHANGE,
  FAQ_URL_RETURN_EXCHANGE_CATEGORY,
} from "@tential/ec-gql-schema/const/karakuri"
import { useCustomMeta } from "~/composables/meta"

const customMeta = useCustomMeta()
useHead(
  customMeta.fetch({
    title: `特定商取引法について`,
    description: "TENTIAL[テンシャル]でのお買い物に際しての特定商取引法に関する詳細情報をこちらでご確認いただけます。",
  }),
)
</script>

<style scoped module lang="scss">
.law_info {
  @include md {
    max-width: $max-width-sm;
    margin: 0 auto;
  }
  .content {
    padding: 0 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    @include md {
      gap: 1.5rem;
    }
    dl {
      dt {
        font-weight: bold;
        font-size: $font-size-15;
        color: $primary;
        @include md {
          font-size: $font-size-17;
        }
      }
      dd {
        font-weight: normal;
        font-size: $font-size-13;
        margin-top: 0.5rem;
        @include md {
          font-size: $font-size-15;
          margin-top: 0.75rem;
        }
        .link {
          text-decoration: underline;
        }
        .sub_title {
          display: inline-block;
          margin: 0.5rem 0 0.25rem;
          font-weight: bold;
          @include md {
            margin: 0.75rem 0 0.5rem;
          }
          &:first-child {
            margin-top: 0;
          }
        }
      }
    }
  }
}
</style>
